// Icons removed since we're using the image from public folder

export const DashboardPreview = () => {
  return (
    <div className="text-white">
      {/* Marketing Text */}
      <div className="mb-6 lg:mb-8 text-center">
        <h2 className="w-full lg:w-2/3 mx-auto leading-tight text-2xl md:text-3xl lg:text-4xl font-medium mb-3 lg:mb-4">
          Manage and Monitor your devices with ease
        </h2>
        <p className="opacity-90 text-sm md:text-base">
          Register to access the power to manage all your devices and manage tickets
        </p>
      </div>

      {/* Dashboard Preview Card */}
      <div className="mx-auto">
        <img 
          src="/authentication_illustrations.svg" 
          alt="Help Desk 411 Dashboard Preview" 
          className="w-full h-auto rounded-lg"
        />
      </div>
    </div>
  )
}
